export const FirstSection = () => {
    
    const listData = [
        "번역", "웹툰 번역", "유튜브 번역", "동시통역", "개발", "프롬포트 언어"
    ]
    
    const linkList = [
        {
            title : "alte 번역 자격증 시험",
            subTitle : "50% 할인 이벤트",
            btnText : "시험 접수",
            url : "#"
        },
        {
            title : "alte 번역 자격증 시험",
            subTitle : "50% 할인 이벤트",
            btnText : "시험 접수",
            url : "#"
        },
        {
            title : "alte 번역 자격증 시험",
            subTitle : "50% 할인 이벤트",
            btnText : "시험 접수",
            url : "#"
        }
    ]
    
    return (
        <section className={`py-24 px-24 w-full h-full flex-col text-center relative bg-cover `}
                 style={{backgroundImage: `url('/images/home/main/bg.png')`}}
        >
            <div className={`bg-white/60 absolute top-0 left-0 w-full h-full `}></div>
            
            <div className={` relative z-10`}>
                <h1 className={`z-40 text-4xl`}>
                    <span className={`z-50  text-blue-800`}>미래를 준비</span>하는 당신을 위한
                    <span className={`z-50  text-blue-600`}>유일한 시험</span>
                </h1>
                
                <h2 className={`text-xl mt-6`}>AI 활용 능력을 자격으로, 경쟁력을 기회로,<br/>
                    번역 실력의 새로운 기준, 당신의 가능성을 입증하세요.</h2>
                
                <ul className={`flex w-full gap-6 my-28 max-w-full`}>
                    {listData.map((item, index) => {
                        return <li
                            className={`w-full flex text-center justify-center flex-col bg-blue-500 rounded-lg py-3 gap-1 ${index % 2 === 0 ? "translate-y-[-38%]" : ""}`}>
                            <div className={`w-[20%] m-auto `}>
                                <img src={`/images/home/main/item/${index + 1}.png`} alt={`bg.png`}
                                     className={`w-full`}/>
                            </div>
                            <div className={`w-full text-white text-xl font-bold mt-2`}>
                                {item} <br/> 자격증
                            </div>
                        </li>
                    })}
                </ul>
                
                <ul className={`flex w-full max-w-full gap-7`}>
                    {
                        linkList.map((item, index) => {
                            return <li
                                className={`w-full py-8 rounded-xl relative overflow-hidden bg-cover`}
                                style={{backgroundImage: `url('/images/home/main/buttonBg/${index + 1}.png')`}}
                            >
                                {/* 반투명 흰색 오버레이 */}
                                <div className="absolute inset-0 bg-white/60 z-0"/>
                                
                                {/* 콘텐츠: 반드시 relative 필요 */}
                                <div className={`relative z-10 text-xl text-left px-12`}>
                                    <h1>{item.title}</h1>
                                    <h2 className={`my-3`}>{item.subTitle}</h2>
                                    <a className={` inline-block text-lg bg-blue-600 px-7 py-1 rounded-full text-white`}
                                       href={item.url}>
                                        {item.btnText}
                                    </a>
                                </div>
                            </li>
                            
                        })
                    }
                </ul>
                <img src="/images/home/main/event.png" alt="event" className={`w-full h-auto rounded-3xl mt-12 z-40`}/>
            </div>
        </section>
    )
}

